import * as React from 'react'
import { IRiderObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import WalletPaneForm from '../../common/WalletPaneForm'
import EditRiderBottomBar from '../EditRiderBottomBar'

interface IWalletPaneProps {
  metadata: IStateMetadata
  rider: IRiderObject
  addRiderPaymentSource: (paymentSource: any, riderId: string) => Promise<any>
  updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
}

class WalletPane extends React.Component<IWalletPaneProps> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    return (
      <WalletPaneForm {...this.props}>
        <EditRiderBottomBar
          cancelPath={`/riders/${this.props.rider.id}/profile/wallet`}
          isSaving={false}
          saveDisabled={true}
        />
      </WalletPaneForm>
    )
  }
}

export default WalletPane



// WEBPACK FOOTER //
// ./src/components/riders/editrider/wallet/WalletPane.tsx